import React, { useEffect, useState } from "react";
import GuideSection from "../components/guide/GuideSection";
import { grhGuide } from "../components/guide/guideContent";
import { formatPrice } from "../utils/formatPrice";
import Header from "../components/header/Header";
import ProgressBar from "../components/progressBar/ProgressBar";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { addToCart } from "../redux/actions/CartActions";
import { FaArrowRight } from "react-icons/fa";
import pricing from "../assets/data/pricing.json";
import { Col, Image, Row } from "react-bootstrap";
import serviceCode from "../assets/data/serviceCode.json";
import { addToServiceList } from "../redux/actions/ServiceListActions";

function PlatformGRH() {
  const navigate = useNavigate();
  const [selectedPlan, setSelectedPlan] = useState("mensuel");
  const currentStep = "Services";
  const steps = [
    "Propriétaire",
    "Entreprise",
    "Services",
    "Paiement",
    "Finalisation",
  ];
  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const handleButtonClick = async () => {
    await dispatch(
      addToCart({
        platformGRH: {
          periodicity: selectedPlan,
          amount:
            selectedPlan === "annuel"
              ? pricing.platformGRH.annuel
              : pricing.platformGRH.mensuel,
        },
      }),
    );
    await dispatch(
      addToServiceList({
        code: serviceCode.platformGRH,
        billing: selectedPlan === "annuel" ? "yearly" : "monthly",
      }),
    );
    navigate("/platform-sale");
  };

  const handleSkipClick = () => {
    navigate("/platform-sale");
  };

  return (
    <div style={{ backgroundColor: "#fff", paddingBottom: "40px" }}>
      <Header />
      <ProgressBar steps={steps} currentStep={currentStep} />

      <>
        <div className="container text-center" style={{ maxWidth: "900px" }}>
          <h4 className="text-2xl font-semibold  mt-4">
            Simplifiez la gestion de vos{" "}
            <span style={{ color: "#FF5500" }}>ressources humaines</span> avec
            <span style={{ color: "#FF5500" }}> PlatformGRH</span>
          </h4>
        </div>

        <div className="container mt-4">
          <Row>
            <Col md={4} className="mb-3">
              <Image
                src="/images/grh/mail_reception.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Gestion des contrats
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <Image
                src="/images/grh/payroll.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Bulletins de paie
              </div>
            </Col>

            <Col md={4} className="mb-3">
              <Image
                src="/images/grh/contract_termination_assistance.webp"
                alt="About"
                fluid
                className="d-block mx-auto"
                height={200}
                width={200}
                style={{ borderRadius: 16 }}
              />
              <div style={{ fontSize: "16px", fontWeight: "500" }}>
                Assistance Rupture Contrats
              </div>
            </Col>
          </Row>
        </div>

        <div className="container text-center">
          <h5 className="mb-3">Choisissez votre abonnement</h5>
          <div className="d-flex justify-content-center gap-4">
            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="mensuel"
                checked={selectedPlan === "mensuel"}
                onChange={() => setSelectedPlan("mensuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.platformGRH.mensuel)} / mois (abonnement
                mensuel)
              </span>
            </label>

            <label style={{ cursor: "pointer" }}>
              <input
                type="radio"
                name="plan"
                value="annuel"
                checked={selectedPlan === "annuel"}
                onChange={() => setSelectedPlan("annuel")}
                className="me-2"
              />
              <span className="font-bold" style={{ color: "#3392FF" }}>
                {formatPrice(pricing.platformGRH.annuel)} / mois (abonnement
                annuel)
              </span>
            </label>
          </div>
        </div>

        <div className="container text-center mt-4">
          <button
            className="btn"
            style={{
              backgroundColor: "#051259",
              color: "#fff",
              borderRadius: "10px",
              padding: "10px 20px",
            }}
            onClick={handleButtonClick}
          >
            Obtenir ce service
            <FaArrowRight style={{ marginLeft: "8px" }} />
          </button>
        </div>

        {cart.from !== "grh" && (
          <div className="container text-center mt-3">
            <span
              onClick={handleSkipClick}
              style={{ color: "#3392FF", cursor: "pointer" }}
            >
              Pas maintenant, peut-être plus tard.
            </span>
          </div>
        )}

        <GuideSection {...grhGuide} />
      </>
    </div>
  );
}

export default PlatformGRH;
